export const HEADLESS_MOBILE = { maxWidth: 768 }
export const LARGE_DESKTOP = { minWidth: 1690 }
export const SMALL_DESKTOP = { maxHeight: 680 }
